<template>
  <footer class="bg-cream-950 text-cream-300 py-16 px-6 lg:px-16">
    <div class="max-w-6xl mx-auto">
      <div class="grid md:grid-cols-2 gap-12 md:gap-16">
        <div>
          <p class="font-mono text-xs uppercase tracking-widest text-cream-500 mb-4">
            Calmren
          </p>
          <p class="text-base text-cream-200 leading-relaxed max-w-md">
            Independent tech consultant. New Zealand.
          </p>
          <p class="text-sm text-cream-400 leading-relaxed max-w-md mt-3">
            Plain tech that fits how you actually work. AI used carefully, where it earns its place.
          </p>
        </div>

        <div class="md:text-right space-y-6">
          <div>
            <h3 class="font-mono text-xs uppercase tracking-widest text-cream-500 mb-3">Get in touch</h3>
            <a
              href="mailto:cal@calmren.com"
              class="font-mono text-sm text-cream-200 hover:text-clay-300 transition-colors"
            >
              cal@calmren.com
            </a>
          </div>
          <div>
            <h3 class="font-mono text-xs uppercase tracking-widest text-cream-500 mb-3">Pages</h3>
            <div class="space-y-2">
              <RouterLink
                v-for="link in links"
                :key="link.to"
                :to="link.to"
                class="block font-mono text-sm text-cream-400 hover:text-cream-100 transition-colors"
              >
                {{ link.label }}
              </RouterLink>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-16 pt-6 border-t border-cream-800 flex flex-wrap items-baseline justify-between gap-2">
        <p class="font-mono text-xs text-cream-600">
          © {{ currentYear }} Calmren. Aotearoa, New Zealand.
        </p>
        <p class="font-mono text-xs text-cream-600">
          Products under <a href="https://sensibleai.nz" class="hover:text-cream-300 transition-colors">Sensible AI</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { RouterLink } from 'vue-router'

const currentYear = computed(() => new Date().getFullYear())

const links = [
  { to: '/',            label: 'Home' },
  { to: '/field-notes', label: 'Field notes' },
  { to: '/contact',     label: 'Contact' },
]
</script>
